module.exports = __webpack_public_path__ + "img/icebycgr-malefique.7c6c0718.jpg";